<template>
  <div
    :id="id"
    class="modal fade"
    data-keyboard="false"
    data-backdrop="static"
  >
    <ValidationObserver v-slot="{ invalid }">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <modal-close-button @confirmed="closeModal" />
            <h4 class="modal-title">PDF ausgeben</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-xl-4">
                <div class="form-group">
                  <ValidationProvider rules="required">
                    <date-picker
                      date-format="dd.mm.yy"
                      placeholder=" "
                      :show-icon="true"
                      :inModal="true"
                      @update="(val) => setDate(val)"
                    />
                    <label>{{ $t('global.date') }}</label>
                  </ValidationProvider>
                </div>
              </div>
              <!-- <div class="col-xl-8">
                <div class="form-group">
                  <v-select
                    v-model="institution"
                    :getOptionLabel="(i) => i?.bezeichnung"
                    :options="institutionen || []"
                    :placeholder="$t('global.institution')"
                  >
                    <span slot="no-options">
                      {{ $t('global.taptosearch') }}
                    </span>
                  </v-select>
                  <label>{{ $t('global.institution') }}</label>
                </div>
              </div> -->
            </div>
            <div class="row">
              <!-- <div
          v-if="kategorie.bezeichnung == 'Zeugnis'"
          class="col-xl-6"
        > -->
              <div class="col-xl-12">
                <span class="radio-title mr-5">{{ $t('global.type') }}:</span>
                <div class="form-group">
                  <ValidationProvider
                    name="Typ"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div class="form-group mb-0">
                      <div
                        class="custom-control custom-radio mb-1 pointer"
                        v-for="option in sichtbareTypOptionen"
                        :key="option.value"
                        @click="ausgewaehlterTyp = option.value"
                      >
                        <input
                          class="custom-control-input"
                          type="radio"
                          name="typ"
                          :id="`typ-${option.value}`"
                          v-model="ausgewaehlterTyp"
                          :value="option.value"
                        />
                        <label
                          class="custom-control-label pointer ml-2"
                          :for="`typ-${option.value}`"
                        >
                          {{ option.label }}
                        </label>
                      </div>

                      <span class="text-danger">{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div
              v-if="printout?.appkey === 'immatrikulationsbestaetigung'"
              class="row"
            >
              <div class="col-6">
                <div class="form-group">
                  <input
                    type="text"
                    name="semester"
                    id="semester"
                    class="form-control input"
                    placeholder="z.B 1. oder letzten"
                    v-model="semester"
                  />
                  <label>{{ $t('global.period') }}</label>
                </div>
              </div>
              <!-- <div class="col-6">
                <div class="form-group">
                  <input
                    type="text"
                    name="schultage"
                    id="schultage"
                    class="form-control input"
                    placeholder="z.B mittwochabends"
                    v-model="schultage"
                  />
                  <label>{{ $t('global.schooldays') }}</label>
                </div>
              </div> -->
            </div>
          </div>

          <div class="modal-footer">
            <!-- deine ValidationProvider hier -->
            <button
              type="button"
              class="btn btn-success"
              @click="datumSetzen()"
              :disabled="invalid"
            >
              PDF ausgeben
            </button>
            <button
              type="button"
              class="btn btn-default"
              @click="closeModal"
            >
              Schliessen
            </button>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
  import DatePicker from '@/components/Datepicker'
  import ModalCloseButton from '@/components/global/ModalCloseButton'

  import { LADE_AUSWAHLWERTE_VERANSTALTUNG } from '@/store/veranstaltung/actions.type'

  import { modal } from '@/mixins/Modal'

  import store from '@/store'
  import CarboneApi from '@/api/CarboneApi'

  export default {
    name: 'DatumPdfModal',
    mixins: [modal],
    components: {
      DatePicker,
      ModalCloseButton,
    },
    store,
    props: {
      id: {
        type: String,
        default: 'datum-pdf-modal',
      },
      kategorie: {
        type: Object,
        required: false,
        default: null,
      },
      printout: {
        type: Object,
        required: false,
        default: null,
      },
    },
    data() {
      return {
        selectedDate: new Intl.DateTimeFormat('ch').format(new Date()),
        ausgewaehlterTyp: null,
        institution: null,
        semester: '',
        schultage: '',
        // typOptionenNachKategorie fällt komplett weg
        printoutdaten: [],
      }
    },
    computed: {
      institutionen: {
        get() {
          return this.$store.state.veranstaltung.institutionen
        },
      },

      // NEU: Optionen aus printoutdaten anhand printout.id bauen
      sichtbareTypOptionen() {
        if (!this.printout || !this.printout.id) return []
        if (!Array.isArray(this.printoutdaten)) return []

        return this.printoutdaten
          .filter((p) => {
            // nur Datensätze für das aktuelle Printout
            const samePrintout = p.printout === this.printout.id
            // optional: nur aktive
            const isActive = !p.aktiv || p.aktiv.toLowerCase() === 'j'
            return samePrintout && isActive
          })
          .map((p) => ({
            value: p.id, // wird später als "type" verschickt
            label: p.bezeichnung, // Anzeige im Radio-Label
          }))
      },
    },
    mounted() {
      if (this.institutionen.length == 0) {
        this.$store.dispatch(`veranstaltung/${LADE_AUSWAHLWERTE_VERANSTALTUNG}`)
      }
      this.loadPrintoutdaten()
    },
    watch: {
      kategorie() {
        this.ausgewaehlterTyp = null
      },
      // wenn das Printout wechselt, Auswahl zurücksetzen
      printout() {
        this.ausgewaehlterTyp = null
      },
    },
    methods: {
      datumSetzen() {
        this.$emit(
          'ok',
          this.selectedDate,
          this.ausgewaehlterTyp, // => type-Parameter im Parent
          // this.institution,
          this.semester,
          this.schultage
        )
        $('#datum-pdf-modal').modal('hide')
      },
      setDate(val) {
        this.selectedDate = val
      },
      async loadPrintoutdaten() {
        try {
          const { data } = await CarboneApi.get('printoutdaten/')
          this.printoutdaten = data
        } catch (e) {
          console.error('Fehler beim Laden der Printoutdaten', e)
        }
      },
    },
  }
</script>

<style></style>
